/**
 * @generated SignedSource<<f8bce11e1d037c12ba14f8ba20a79283>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useShowRoadmapsUpsell$data = {
  readonly jira: {
    readonly stringUserProperty: {
      readonly stringValue: string | null;
    } | null;
  } | null;
  readonly " $fragmentType": "useShowRoadmapsUpsell";
};
export type useShowRoadmapsUpsell$key = {
  readonly " $data"?: useShowRoadmapsUpsell$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShowRoadmapsUpsell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "ownerAri"
    }
  ],
  "kind": "Fragment",
  "name": "useShowRoadmapsUpsell",
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "accountId",
              "variableName": "ownerAri"
            },
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            },
            {
              "kind": "Literal",
              "name": "propertyKey",
              "value": "jpd-roadmaps-upsell.dismissed"
            }
          ],
          "concreteType": "JiraEntityPropertyString",
          "kind": "LinkedField",
          "name": "stringUserProperty",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "stringValue"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "50048fec27fda90103711c524550bbac";

export default node;
